import { EndpointType } from "../BaseEndpoint";

export const WithGet = <EndpointT extends EndpointType, T>(clazz: EndpointT) =>
  class extends clazz {
    /**
     * Get a single resource by id
     *
     * @param id The id of the resource to fetch
     */
    get(id: string): Promise<T> {
      return this.request(id);
    }
  };
